module.exports = {
  animationDuration: 500,
  positiveIconTrackName: 'thumbs_up',
  negativeIconTrackName: 'thumbs_down',
  negativeFeedbackResponse: 'Want to add a few words to explain why?',
  positiveFeedbackResponse: 'Great! Thanks for your feedback',
  questionText: 'Did you find this article useful?',
  afterFeedbackText: ' ',
  afterWrittenFeedbackText: 'Thanks for your feedback',
  writtenFeedbackTrackName: 'feedback_field',
  writtenFeedbackPlaceholder: 'Enter your feedback here',
  buttonText: 'Send feedback',
  buttonTrackName: 'submit_feedback'
}


// WEBPACK FOOTER //
// ./config/feedbackSection.js